import { DEFAULT_THEME } from '@/config/theme'

const CSS_VAR_MAP = {
  sidebarBg: '--theme-sidebar-bg',
  sidebarSubBg: '--theme-sidebar-sub-bg',
  sidebarHoverBg: '--theme-sidebar-hover-bg',
  sidebarText: '--theme-sidebar-text',
  sidebarActive: '--theme-sidebar-active',
  headerBg: '--theme-header-bg',
  headerBorder: '--theme-header-border',
  headerText: '--theme-header-text',
}

export function applyTheme(themeInput) {
  const theme = { ...DEFAULT_THEME, ...(themeInput || {}) }
  const root = document.documentElement

  Object.keys(CSS_VAR_MAP).forEach((key) => {
    root.style.setProperty(CSS_VAR_MAP[key], theme[key] || DEFAULT_THEME[key])
  })

  return theme
}
